const renderPdf = {
  header: 'Most popular sectors',
};

export default renderPdf;
